import { attr, Model, ModelType } from 'redux-orm'

import {
  GET_MODIFIERS_FAIL,
  GET_MODIFIERS_SUCCESS,
  RESET_MODIFIER_IDS,
  ResolvedAction,
} from 'actions/modifiers'
import { PaginationT } from 'models/Pagination'
import { Fields as ProductFields } from 'models/Product'

export interface Fields {
  uid: string
  option: Option
  items: Item[]
}

export interface Option {
  chain_uid: string
  name: string
  price: number
  image?: {
    default: string | null
  }
  paths: Array<Array<string>>
}

export type Item = Omit<ProductFields, 'image'>

export interface OptionItems {
  option: Option
  items: Item[]
  pagination: PaginationT
}

// We only extend 'Model' here, not 'Model<Modifier, Fields>' due to constraints with
// redux-orm's type definitions.
// https://github.com/redux-orm/redux-orm/issues/631
export default class Modifier extends Model {
  static modelName: string = 'Modifier'
  static options = { idAttribute: 'uid' }

  static get fields(): any {
    return {
      uid: attr(),
      option: attr(),
      items: attr(),
    }
  }

  static reducer(
    action: ResolvedAction | { type: typeof RESET_MODIFIER_IDS },
    Modifier: ModelType<Modifier>
  ): void {
    switch (action.type) {
      case GET_MODIFIERS_SUCCESS: {
        const { option_items = [] } = action.payload.data
        // We rely on Redux-ORM's idAttribute and upsert logic for deduplication.
        option_items.forEach(modifier => {
          Modifier.upsert({
            ...modifier,
            uid: modifier.option.chain_uid,
            // 'id' is required for upsert
            id: modifier.option.chain_uid,
          })
        })
        break
      }

      case GET_MODIFIERS_FAIL: {
        if (
          !action.error ||
          !action.error.message ||
          action.error.message !== 'Request was canceled due to new one.'
        ) {
          Modifier.all().delete()
        }
        break
      }

      case RESET_MODIFIER_IDS:
        Modifier.all().delete()
        break
    }
  }
}
